import { HttpErrorResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PromiseResult } from '../models/PromiseResult';
import { RestApi } from '../shared/apiUrls';
import { Observable, throwError } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { DeleteMessage, GetAllQuery, GetMessageQuery, GetNewQuery, NewMessage, PatientProfileQuery, UpdateMessage } from '../models/message';
import { roles } from '../constant/constant';

@Injectable({
    providedIn: 'root'
})
export class MessagecenterService {

    constructor(private readonly http: HttpClient) { }


    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    // common

    GetAllMessages(query: GetAllQuery, user: roles): Observable<PromiseResult> {
        let params = new HttpParams()
            .set('sent', query.sent.toString())
            .set('page_no', query.page_no.toString())
            .set('messages_per_page', query.messages_per_page.toString())
        if (query.patient_guid != null) params = params.append('patient_guid', query.patient_guid);
        if (query.user_guid != null) params = params.append('user_guid', query.user_guid);
        if (query.flagged != null) params = params.append('flagged', query.flagged.toString())
        return this.http.get<PromiseResult>(RestApi.Urls.MessageApi + user + "/GetAll", { params })
            .pipe(catchError(this.handleError));
    }

    GetFullMessage(query: GetMessageQuery, user: roles): Observable<PromiseResult> {
        let params = new HttpParams()
            .set('sent', query.sent.toString())
            .set('message_id', query.message_id.toString())
        if (query.patient_guid != null) params = params.append('patient_guid', query.patient_guid);
        if (query.user_guid != null) params = params.append('user_guid', query.user_guid);
        return this.http.get<PromiseResult>(RestApi.Urls.MessageApi + user + "/Get", { params })
            .pipe(catchError(this.handleError));
    }

    GetNewMessage(query: GetNewQuery, user: roles): Observable<PromiseResult> {
        let params = new HttpParams()
            .set('sent', query.sent.toString())
            .set('total_messages', query.total_messages.toString())
        if (query.patient_guid != null) params = params.append('patient_guid', query.patient_guid);
        if (query.user_guid != null) params = params.append('user_guid', query.user_guid);
        return this.http.get<PromiseResult>(RestApi.Urls.MessageApi + user + "/Get/New", { params })
            .pipe(catchError(this.handleError));
    }



    CreateMessage(query: NewMessage, user: roles): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.MessageApi + user + "/Create", query)
            .pipe(catchError(this.handleError));
    }

    UpdateMessages(query: UpdateMessage, user: roles, user_guid: string, patient_guid: string): Observable<PromiseResult> {
        let guid: string;
        if (user_guid == null) guid = patient_guid;
        else guid = user_guid;
        return this.http.put<PromiseResult>(RestApi.Urls.MessageApi + user + "/Update/" + guid, query)
            .pipe(catchError(this.handleError));
    }

    DeleteMessages(query: DeleteMessage, user: roles, user_guid: string, patient_guid: string): Observable<PromiseResult> {
        let guid: string;
        if (user_guid == null) guid = patient_guid;
        else guid = user_guid;
        return this.http.patch<PromiseResult>(RestApi.Urls.MessageApi + user + "/Update/" + guid + "/delete", query)
            .pipe(catchError(this.handleError));
    }



    fetchPatientMessages(query: PatientProfileQuery): Observable<PromiseResult> {
        const params = new HttpParams()
            .set('page_no', query.page_no.toString())
            .set('records_per_page', query.records_per_page.toString())
            .set('patient_guid', query.patient_guid)
            .set('sent', query.sent.toString())
        return this.http.get<PromiseResult>(RestApi.Urls.MessageApi + 'patient/profile/fetch', { params })
            .pipe(catchError(this.handleError))
    }



    getMessagesForDashborad(user: roles): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.MessageApi + user + '/dashboard/new'
            )
            .pipe(catchError(this.handleError));
    }
}
